export default "/static/img/logo_scorpios.png";